import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { MVP_CRITERIA, MVP_PATHS } from './salesData';
export function MethodSection() {
  return <section id="metodo" className="bg-charcoal py-14 text-white sm:py-20" data-id="element-210" data-mp="2tyxhcar53qa">
      <div className="mx-auto max-w-5xl px-5" data-id="element-211" data-mp="2wbftqkf9g3v">
        <div className="text-center" data-id="element-212" data-mp="3uyt43inp4v0a">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 font-display text-[0.64rem] font-bold uppercase tracking-editorial text-coral" data-id="element-213" data-mp="3uzuctgh8p5eu">
            <span className="h-1.5 w-1.5 rounded-full bg-coral" aria-hidden data-id="element-214" data-mp="ql4brn11nnyh" />
            El mecanismo
          </span>
          <h2 className="mx-auto mt-4 max-w-[16ch] font-display text-[1.75rem] font-extrabold leading-[1.1] tracking-tight sm:max-w-[24ch] sm:text-[2.6rem]" data-id="element-215" data-mp="lr9yb1c1857u">
            Método M.V.P.™
            <span className="mt-1 block text-coral" data-id="element-216" data-mp="1eayom4ld5ciq">Menú Vendible de Partida</span>
          </h2>
          <p className="mx-auto mt-4 max-w-[44ch] font-sans text-[0.93rem] leading-relaxed text-white/70 sm:max-w-2xl sm:text-[1rem]" data-id="element-217" data-mp="19h481a121dnv">
            No necesitás vender 60 productos. El sistema te enseña a elegir alrededor de{' '}
            <strong className="font-bold text-white" data-id="element-218" data-mp="2036c0o1v3mma">5 productos estratégicos</strong> para empezar.
          </p>
        </div>

        <div className="mt-10 grid gap-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:items-start lg:gap-12" data-id="element-219" data-mp="1qb0ktgjfp985">
          <div data-id="element-220" data-mp="1cbhm1ecija8i">
            <h3 className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-coral" data-id="element-221" data-mp="1cay8e9twb80a">
              Se eligen según
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5" data-id="element-222" data-mp="12dtgruha6kc3">
              {MVP_CRITERIA.map(c => <li key={c} className="flex items-center gap-2 rounded-xl bg-white/[0.07] px-3 py-2.5 font-sans text-[0.8rem] font-medium text-white/90 sm:text-[0.86rem]" data-id="element-223" data-mp="17ceglssmf200">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-coral" aria-hidden strokeWidth={3} data-id="element-224" data-mp="31pmha13a27tk" />
                  {c}
                </li>)}
            </ul>
          </div>

          <div data-id="element-225" data-mp="2va5sebd8a0so">
            <h3 className="font-display text-[0.68rem] font-bold uppercase tracking-editorial text-coral" data-id="element-226" data-mp="2v9nr30bpkwdw">
              Tres caminos posibles
            </h3>
            <div className="mt-4 grid gap-3" data-id="element-227" data-mp="2ma0nq8zf5gi7">
              {MVP_PATHS.map((path, i) => <motion.div key={path.name} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.28,
              ease: [0.23, 1, 0.32, 1],
              delay: i * 0.05
            }} className="rounded-2xl bg-white/[0.07] p-5 ring-1 ring-white/10" data-id="element-228" data-mp="3izqf95ci5i78" data-mpi={i}>
                  <p className="font-display text-[1.05rem] font-bold tracking-tight text-white sm:text-[1.2rem]" data-id="element-229" data-mp="5lda2ic70gu4">
                    {path.name}
                  </p>
                  <p className="mt-1.5 font-sans text-[0.87rem] leading-relaxed text-white/70" data-id="element-230" data-mp="1jh4vz1y3tx7a">
                    {path.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>

        <p className="mx-auto mt-12 max-w-[26ch] text-center font-display text-[1.45rem] font-extrabold leading-[1.15] tracking-tight text-coral sm:max-w-[36ch] sm:text-[2.1rem]" data-id="element-231" data-mp="1sgrxrouqx50v">
          No necesitás otras 500 recetas. Necesitás saber con cuáles empezar.
        </p>
      </div>
    </section>;
}